<template>
    <tr>
        <td>
            {{ title }}
        </td>
        <td id="propertyTableIcons">
            <ul class="list list-icons list-secondary row m-0 list-inline" id="propertiesList">
                <li class="list-inline-item entry" v-for="entry in entries" :key="entry.tooltip">
                    <i :class="computeClass(entry)" :style="entry.style" data-toggle="tooltip" data-placement="top" :title="entryTooltip(entry)"></i> 
                </li>
            </ul>
        </td>
    </tr>
</template>

<script>
export default {
    name: 'TablePropertyEntry',
    props: {
        title: {
            type: String, 
            default: ''
        },
        entries: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    mounted: function(){
        // Enable all the tooltips
        $('[data-toggle="tooltip"]').tooltip();
    },
    methods: {
        computeClass: function(icon) {
            return icon.icon + " icon " + (icon.data ? "present" : "");
        },
        entryTooltip: function(entry) {
            return `${entry.tooltip}: ${entry.data ? this.$i18n.t("common.generic.yes") : this.$i18n.t('common.generic.no')}`;
        }
    }
}
</script>

<style scoped lang="scss">
    .entry {
        width: 20px !important; 
        height: 20px !important;
    }

    .icon {
        color: rgb(204, 204, 204) !important;
        margin: 1px;
    }

    .icon.present {
        color: $primary-color !important;
    }

    #propertyTableIcons {
        padding-top: 3px;
    }

    .list-inline-item > i {
        font-size: 20px;
    }

    .smallPropertyIcon {
            font-size: 25px !important;
            height: 35px !important;
            line-height: 35px !important;
        }

        td {
            font-family: "Open Sans", sans-serif;
            font-weight: 400;
        }
</style>